(function ($, Drupal) {
  'use strict'

  Drupal.behaviors.autofill = {
    attach: function (context, settings) {
      $(once("autofill", ".js-form-autofill", context))
        .each(function (i, autofill) {
          initAutofill(autofill);
        });

      function initAutofill(input) {
        const form = input.closest('form');
        const street = form.querySelector('.js-autofill-street');
        const zip = form.querySelector('.js-autofill-zipcode');
        const city = form.querySelector('.js-autofill-city');
        const idPlace = form.querySelector('.js-google-places-id');
        const country = form.querySelector('.js-country');
        const province = form.querySelector('.js-province');
        const inputs = form.querySelectorAll('.js-form-row-autofill-additional');
        const more = form.querySelector('.js-autofill-more');
        let siteCounty = document.getElementsByTagName('BODY')[0].getAttribute('data-page-country');
        const validatedByGoogle = form.querySelector('.js-validated-by-google-map');
        if (country && document.querySelector('body').dataset.akamaiCountryName && document.querySelector('body').dataset.akamaiCountryName !== '') {
          $(country).val(document.querySelector('body').dataset.akamaiCountryName);
          $(country).trigger('change');
          country.closest('.js-form-row-autofill-additional').classList.add('has-focus');
        }
        if (siteCounty && siteCounty !== 'OTHER') {
          siteCounty = siteCounty.toLowerCase();
        } else {
          siteCounty = '';
        }
        const observer = new MutationObserver(() => {
          observer.disconnect();
          input.setAttribute('autocomplete', 'new-password');
        });
        observer.observe(input, {
          attributes: true,
          attributeFilter: ['autocomplete']
        });
        const autocomplete = new google.maps.places.Autocomplete(input);
        if (siteCounty !== '') {
          autocomplete.setComponentRestrictions(
            {'country': [siteCounty]});
        }
        autocomplete.addListener('place_changed', () => {
          const place = autocomplete.getPlace();
          if (place.address_components) {
            input.value = place.name;
            if (street) {
              street.value = '';
            }
            if (city) {
              city.value = '';
            }
            if (zip) {
              zip.value = '';
            }
            if (country) {
              country.value = '';
            }
            if (province) {
              province.value = '';
            }
            if (idPlace) {
              idPlace.value = '';
            }
            place.address_components.forEach((placeElement) => {
              if (placeElement.types) {
                placeElement.types.forEach((typeElemet) => {
                  switch (typeElemet) {
                    case 'route':
                      if (street) {
                        street.value = `${placeElement.long_name} ${street.value}`;
                      }
                      break;
                    case 'street_number':
                      if (street) {
                        street.value = placeElement.long_name;
                      }
                      break;
                    case 'locality':
                      if (city) {
                        city.value = placeElement.long_name;
                      }
                      break;
                    case 'postal_code':
                      if (zip) {
                        zip.value = placeElement.long_name;
                      }
                      break;
                    case 'country':
                      if (country) {
                        $(country).val(placeElement.long_name);
                      }
                      break;
                    case 'administrative_area_level_2':
                      if (province) {
                        province.value = placeElement.long_name;
                      }
                      break;
                    default:
                      break;
                  }
                });
              }
            });
            if (place.place_id) {
              idPlace.value = place.place_id;
            }
            if (inputs.length) {
              more.classList.add('hide');
              inputs.forEach((input) => {
                const field = input.querySelector('input');
                input.classList.add('show');
                if (field) {
                  field.focus();
                  field.blur();
                }
              });
              if (country) {
                country.focus();
                country.blur();
                $(country).trigger('change');
              }
            }
            if (validatedByGoogle) {
              validatedByGoogle.value = 'true';
            }
          }
        });

        inputs.forEach((input) => {
          const field = input.querySelector('input');
          if (field) {
            field.addEventListener('keyup', () => {
              if (validatedByGoogle) {
                validatedByGoogle.value = 'false';
              }
              idPlace.value = '';
            });
          }
        });
        if (country) {
          $(country).on('select2:select', () => {
            if (validatedByGoogle) {
              validatedByGoogle.value = 'false';
            }
            idPlace.value = '';
          });
        }
        input.addEventListener('keyup', () => {
          if (input.value.trim() === '') {
            idPlace.value = '';
            inputs.forEach((input) => {
              const field = input.querySelector('input');
              if (field) {
                field.value = '';
                field.classList.remove('not-empty');
                input.classList.remove('has-focus');
              }
            });
            if (country) {
              country.classList.remove('not-empty');
              country.closest('.js-form-row-autofill-additional').classList.remove('has-focus');
              $(country).val('');
              $(country).trigger('change');
            }
          }
        });

        more.addEventListener('click', () => {
          more.classList.add('hide');
          inputs.forEach((input) => {
            input.classList.add('show');
          });
        });
      }
    }
  }

}) (jQuery, Drupal)
